export default "a2639ddd761c4504.svg"